module.exports = __webpack_public_path__ + "static/media/landingtrans.e92b5d58.png";